/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/aria-role */
import React from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import './index.scss'

const links = [
  {
    name: 'about'
  },
  {
    name: 'portfolio'
  },
  {
    name: 'blog'
  },
  {
    name: 'contact'
  }
]
const openMenu = () => {
  document.getElementById('overlay').style.width = '100%'
}
const closeMenu = () => {
  document.getElementById('overlay').style.width = '0%'
}

const NavBar = () => {
  return (
    <div className="navbar">
      <ul className="navbar__logo">
        <li className="navbar__logo-name">
          <Link to="/"> adityagyawali </Link>
        </li>
      </ul>
      <FontAwesomeIcon
        style={{ cursor: 'pointer' }}
        onClick={openMenu}
        className="hamburg__menu"
        icon={faBars}
      />
      <div id="overlay" className="overlay">
        <span style={{ cursor: 'pointer' }} className="closebtn" onClick={closeMenu}>
          &times;
        </span>
        <ul className="overlay-content">
          {links.map(link => (
            <li key={link.name}>
              <Link to={`/${link.name}`}>{link.name}</Link>
            </li>
          ))}
        </ul>
      </div>
      <ul className="navbar__links">
        {links.map(link => (
          <li key={link.name}>
            <Link to={`/${link.name}`}>{link.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default NavBar
